var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _defs, _symbol6, _use;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgRainshowersPolartwilight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "raindrop"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0062bf",
    d: "M2.5,13A2.5,2.5,0,0,1,.21,9.51l3.55-8a2.5,2.5,0,0,1,4.57,2l-3.55,8A2.5,2.5,0,0,1,2.5,13Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "cloud"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7,5A23.94,23.94,0,0,0,34.37,18.05a9.9,9.9,0,0,0-12.78,5.56,15,15,0,0,0-1.71-.1A14.81,14.81,0,0,0,9.2,28,14.63,14.63,0,0,0,5,38.17v.21A14.83,14.83,0,0,0,19.88,53.06H75.59a14.3,14.3,0,0,0,3.67-28.14A23.93,23.93,0,0,0,55.7,5Z"
  }), /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 14,
    width: 85,
    height: 43,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAAAkCAMAAAAkYj0PAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURSgoKExpcaCgoFBQUG5ublBQUISEhI1fsT0AAAAHdFJOUxsACBsPFRpGXuFgAAABWElEQVRIx7XV25bDIAgF0BMu/v8nF/E+iWlqHNKVN3cpIMXxL4GFM3SQfTazkUyxk63oLYwlVSy2silXkS/wUrZS2a3ZCn1zsdSw7UUYijuHsTa1IvfwWrbSXLkc4N9r27JViwmM1UtWXA3hohQ41m6vl8FQZi7wu2z7KXPW4uRiZS+2AmdXN7DdQEQWQHYHlt6z0dXBBa2xeeVktiZc1jDoF5eGkI4d4MjKc7cNbZ3bqjocLLx5oPDYTaIftcfvAvcs2GFxVsJTOP1wO1jGdUSLaz/DWA1Tl45+Tkqul2ArcPzayGq8JafOUffP3TUp6JQs+Rptc6vtmtBkUw+dv0NzWG0PYf8O7Ym09+ITXyXOPZqEX95aFe3PKxRsL2XV3HR+ZALirPSF0ceHp6F51WBv1A22VaW2GHWzWvat8LOAPf4CrjrA+neNK7+PQBf/DmmLrId09/QDWyESBsibwBUAAAAASUVORK5CYII="
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "sun"
  }, /*#__PURE__*/React.createElement("path", {
    className: "sun-glow",
    fill: "url(#sun-glow-grad)",
    d: "M66.64,47.86,82,41,66.64,34.12l9.84-13.66L59.76,22.22,61.46,5.47l-13.6,9.89L41,0,34.12,15.36,20.46,5.52l1.76,16.72L5.47,20.54l9.89,13.6L0,41l15.36,6.83L5.52,61.54l16.72-1.76L20.54,76.53l13.6-9.89L41,82l6.83-15.36,13.66,9.84L59.78,59.76l16.75,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sun-outer",
    fill: "#ffd348",
    d: "M19.28,53.5a25,25,0,1,0,9.15-34.16A25,25,0,0,0,19.28,53.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sun-inner",
    fill: "url(#sun-inner-grad)",
    d: "M22.74,51.5a21,21,0,1,0,7.69-28.69A21,21,0,0,0,22.74,51.5Z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "s09"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cloud",
    fill: "#b2b2b2",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    transform: "translate(3,18) scale(1,1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#raindrop",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    transform: "translate(32,78) scale(1,1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#raindrop",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    transform: "translate(45,87) scale(1,1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#raindrop",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    transform: "translate(60,78) scale(1,1)"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "sunWinter"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#sunWinterMask)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "sun-primitive",
    xlinkHref: "#sun",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    transform: "translate(4,-40) scale(1,1)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M88.29,2.7H1.71A1.56,1.56,0,0,1,0,1.35,1.56,1.56,0,0,1,1.71,0H88.29A1.56,1.56,0,0,1,90,1.35,1.56,1.56,0,0,1,88.29,2.7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "cloud_3_18_1_1_5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cloud",
    fill: "black",
    stroke: "black",
    strokeLinejoin: "round",
    strokeWidth: 10,
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    transform: "translate(3,18) scale(1,1)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "sunWinterMask"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sun-glow-grad",
    cx: 41,
    cy: 41,
    r: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "#d6b849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "67%",
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffdb73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sun-inner-grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffaf22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f09900"
  })))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "s05m"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#cloud_3_18_1_1_5)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sunWinter",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    transform: "translate(0,19) scale(0.7,0.7)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s09",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s05m",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainshowersPolartwilight);
export default __webpack_public_path__ + "static/media/rainshowers_polartwilight.3416eddaf730529b2a9cb1492ca544e1.svg";
export { ForwardRef as ReactComponent };